import * as React from "react";
import RevoMenuItemGroup from "../revo-menu-item-group";
import { RevoMainMenuItem } from "../revo-main-menu-item";
import { isBeta } from "../../menu/beta";
import { scopeRequirementIsFulfilled } from "../../helper/scopesfromcookie";
import { reportActiveModule, reportActiveSection, } from "../../components/util/location-change";
import { isUserImpersonating } from "../revo-main-menu";
export function allowedProducts() {
    const twentyOneWindow = window.twentyone;
    return twentyOneWindow && twentyOneWindow.allowedProducts;
}
function isProductAvailable(productRequirement) {
    const products = allowedProducts();
    return products ? products.some((_) => _ === productRequirement) : true;
}
export function filterMenuEntries(entries, scopes) {
    return entries
        .filter((_) => (_.beta ? isBeta() : true))
        .filter((_) => _.productRequirement ? isProductAvailable(_.productRequirement) : true)
        .filter((_) => _.scopeRequirement
        ? scopeRequirementIsFulfilled(_.scopeRequirement, scopes)
        : true);
}
export function renderGroup(entries, index, activeSubmenu, onMouseEnter, onMouseLeave, activeModule, modulePage, scopes, currentLocation) {
    const menuEntries = filterMenuEntries(entries, scopes).filter((_) => !_.toolsPopup);
    if (menuEntries.length === 0) {
        return null;
    }
    else {
        return (React.createElement(RevoMenuItemGroup, { key: index, onMouseEnter: () => onMouseEnter(), onMouseLeave: () => onMouseLeave() }, menuEntries.map((entry, entryIndex) => {
            const currentMenuSectionEntry = currentLocation &&
                menuEntries.find((me) => me.app === currentLocation.app &&
                    me.entry === currentLocation.submenu &&
                    (!me.module || me.module === currentLocation.module));
            const singleAppNavigationAvailable = entry.singleAppNavigation &&
                currentMenuSectionEntry &&
                entry.app === currentMenuSectionEntry.app &&
                currentMenuSectionEntry.service === entry.service;
            const onSectionClick = singleAppNavigationAvailable
                ? () => {
                    if (entry.module) {
                        reportActiveModule({
                            app: entry.app,
                            section: entry.entry,
                            module: entry.module,
                        });
                    }
                    else {
                        reportActiveSection(entry.app, entry.entry);
                    }
                }
                : undefined;
            const isActiveSection = entry === currentMenuSectionEntry &&
                (!modulePage || !!entry.module) &&
                !activeModule;
            const isImpersonating = isUserImpersonating();
            return (React.createElement(React.Fragment, { key: "menu-item-group-" + index + "entry-" + entryIndex },
                React.createElement(RevoMainMenuItem, { location: currentLocation, key: "entry-" + index + "-" + entry.entry, service: entry.service, path: entry.path, icon: entry.icon, text: entry.text, active: isActiveSection, beta: entry.beta, onClick: onSectionClick, scopes: scopes, isImpersonating: isImpersonating }),
                entry.modules &&
                    entry.modules
                        .filter((entryModule) => entryModule.scopeRequirement
                        ? scopeRequirementIsFulfilled(entryModule.scopeRequirement, scopes)
                        : true)
                        .map((entryModule) => {
                        const isActiveModule = entryModule.module === "assessment"
                            ? activeModule === "assessments"
                            : activeModule === entryModule.module;
                        const appModuleLocation = {
                            app: entry.app,
                            section: entry.entry,
                            module: entryModule.module,
                        };
                        const onSubmoduleClick = singleAppNavigationAvailable
                            ? () => reportActiveModule(appModuleLocation)
                            : undefined;
                        return (React.createElement(RevoMainMenuItem, { location: currentLocation, key: entryModule.module, service: entry.service, path: entryModule.path, icon: entryModule.icon, text: entryModule.text, active: isActiveModule, beta: entry.beta, module: entryModule.module, onClick: onSubmoduleClick, scopes: scopes, isImpersonating: isImpersonating }));
                    })));
        })));
    }
}
//# sourceMappingURL=submenu-entry.js.map